// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { AbstractTableFilter, AbstractTableFilterSchema } from 'api/gen/AbstractTableFilter';

const requiredPart = t.interface({
  tag: t.literal('GREATER_THAN_EARTAG'),
  countryCode: t.union([t.string, t.null]),
  field: t.string,
  value: t.Integer,
});

export const GreaterThanEarTagFilterSchema = excess(t.intersection([AbstractTableFilterSchema.type, requiredPart]));

export interface GreaterThanEarTagFilter extends t.TypeOf<typeof GreaterThanEarTagFilterSchema> {}
